// The frame every shot is drawn into (9:16, in frame units), how a picture fits it, and the camera's view of it.
import type { Camera } from "../model/episode";

export const FRAME_W = 360;
export const FRAME_H = 640;

export type View = { x: number; y: number; w: number; h: number };

export const WHOLE: Camera = { cx: 0.5, cy: 0.5, zoom: 1 };
export const MAX_ZOOM = 6; // shots hold small faces in big pictures

// How a picture sits in the frame: scaled to cover it, centred (pictures are made 9:16, so nothing is cut off).
export function pictureFit(p: { w: number; h: number }) {
  const s = Math.max(FRAME_W / p.w, FRAME_H / p.h);
  return { s, x: (FRAME_W - p.w * s) / 2, y: (FRAME_H - p.h * s) / 2 };
}

// The rectangle of the frame the camera shows. It always stays inside the frame.
export function viewRect(cam: Camera): View {
  const zoom = Math.min(8, Math.max(1, cam.zoom));
  const w = FRAME_W / zoom, h = FRAME_H / zoom;
  const clamp = (v: number, max: number) => Math.max(0, Math.min(max, v));
  return { x: clamp(cam.cx * FRAME_W - w / 2, FRAME_W - w), y: clamp(cam.cy * FRAME_H - h / 2, FRAME_H - h), w, h };
}

export const sameCamera = (a: Camera, b: Camera) => Math.abs(a.cx - b.cx) < 1e-3 && Math.abs(a.cy - b.cy) < 1e-3 && Math.abs(a.zoom - b.zoom) < 1e-3;
